const prefetchCache = new Map();

export const setSettlementPrefetch = (challanId, promise) => {
    prefetchCache.set(String(challanId), promise);
};

export const takeSettlementPrefetch = (challanId) => {
    const key = String(challanId);
    const promise = prefetchCache.get(key);
    prefetchCache.delete(key);
    return promise ?? null;
};
